<template>
    <div class="ion-page">
    <ion-header>
      <ion-toolbar>
        <ion-buttons v-slot: start>
          <ion-menu-button></ion-menu-button>
          <ion-title>Manage Reservations</ion-title>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">
      <Reservations />
    </ion-content>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import Reservations from "@/components/admin/Reservations.vue";
import { IonButtons, IonContent, IonHeader, IonMenuButton, IonTitle, IonToolbar } from '@ionic/vue';

export default defineComponent({
    name:  'reservations',
    components: {
        Reservations, IonHeader, IonToolbar, IonButtons, IonMenuButton, IonTitle, IonContent
    },
    data() {
        return {

        }
    },
})
</script>
